'use client';

import { Suspense } from 'react';
import { usePageTrack } from '@tv2/lib-offspring/hooks/tracking/usePageTrack';
import { Four04 } from '@/components/errors/Error';
import { ErrorPageChrome } from '@/components/errors/ErrorPageChrome';
import { MainProviders } from '@/app/providers';

function NotFoundContent() {
  usePageTrack({
    pageType: 'error',
    httpCode: '404',
  });

  return <Four04 />;
}

/**
 * 404 page, rendered when a route or Server Component calls `notFound()`, or
 * for unmatched URLs at the application root.
 *
 * This file lives at the app root — outside the `(app)` route group — so it
 * does not inherit the hoisted provider tree and must provide its own via
 * `MainProviders` (the error UI and its tracking hook depend on the
 * user/profile/subscription contexts).
 *
 * The provider tree is wrapped in `<Suspense>` because the navigation chrome
 * calls `useSearchParams()`, which Next.js requires to be inside a Suspense
 * boundary when a route can be statically prerendered (e.g. `/_not-found`).
 */
export default function NotFound() {
  return (
    <Suspense>
      <MainProviders environment={null}>
        <ErrorPageChrome>
          <NotFoundContent />
        </ErrorPageChrome>
      </MainProviders>
    </Suspense>
  );
}
